import "./WaterDamageFloodRestoration.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Overview from "./sections/Overview";
import Process from "./sections/Process";
import WhyChoose from "./sections/WhyChoose";
import Faqs from "./sections/Faqs";
import Intake from "./sections/Intake";
import Footer from "@/reusable_sections/Footer";
export default function WaterDamageFloodRestorationPage() {
  return <div>
      <Header />
      <Hero />
      <Overview />
      <Process />
      <WhyChoose />
      <Faqs />
      <Intake />
      <Footer />
    </div>;
}